<template>
    <div class="container">
        <h4 class="title is-4">Page Not Found</h4>
    </div>
</template>

<script>
  export default {
    name: "screen404"
  }
</script>

<style scoped>

</style>